import { generateCrud } from './helpers'

export default function () {
  const crud = generateCrud('/api/trash')

  return {
    read: crud.read
  }
}
